<template>
  <nx-dialog
    :visible.sync="show"
    :title="title"
    width="1000px"
    :before-close="beforeClose"
    :show-btn="false"
    :canHideFoot = "false"
    v-if="show"
  >
    <nx-detail :source="itemDic" :config="config" />
    <nx-table ref="nxTable" :data="tableData" table-title="诊断记录" @search="search">
      <template v-slot:operation>
        <el-button icon="iconfont icon-daochu_blue" type="primary" @click="handExport">{{
          '导出'
        }}</el-button>
      </template>
      <el-table-column v-if="type === '1'" label="故障码类型" prop="faultCodeType"  />
      <el-table-column v-if="type === '1'" label="DTC信息" prop="dtc"  />
      <el-table-column v-if="type !== '1'" label="DID参数" prop="didParam"  />
      <el-table-column v-if="type !== '1'" label="DID值" prop="didData" />
    </nx-table>
  </nx-dialog>
</template>
<script>
import {
  fileStatusArr,
  powerTypes,
  responseResultsTypes,
  udsConmondTypes,
  udsItemTypes,
  collectMethodTypes,
  frameTypes,
  canTypes,
  // vehiclePurposeTypes
} from '../../config.js';

import { getUdsCheckList, exportUdsItemList, getUdsCheckDetials, getUdsItemList } from '@/api/dataService/udsV2.js';
export default {
  props: {
    visible: {
      type: Boolean,
    },
    title: {
      type: String,
      default: '',
    },
    id: {
      type: [String,Number],
      default: '',
    },
    type: {
      type: [String,Number],
      default: '',
    },
    itemDic: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      udsConmondTypes,
      collectMethodTypes,
      udsItemTypes,
      frameTypes,
      canTypes,
      show: false,
      tableData: [],
    };
  },
  computed: {
    config() {
      return [
        {
          key: 'vin',
          label: 'VIN:',
          span: 8,
        },
        {
          key: 'iccid',
          label: 'ICCID' + ':',
          span: 8,
        },
        {
          key: 'realTime',
          label: 'CAN数据采集时间' + ':',
          span: 8,
        },
        {
          key: 'requestCanId',
          label: '请求CAN_ID' + ':',
          span: 8,
        },
      ];
    },
  },
  watch: {
    id: {
      handler(id) {
        if (id) this.getDetail(id);
      },
    },
    visible: {
      handler(visible) {
        this.show = visible;
        if (visible) {
        }
      },
    },
    show: {
      handler(show) {
        this.$emit('update:visible', show);
      },
    },
  },
  created() {},
  mounted() {},
  methods: {
    async onConfirm() {
      this.show = false;
      this.$emit('onConfirm', params);
    },
    beforeClose(done) {
      // this.$refs.submitForm.resetFields();
      this.tableData = [];
      done();
    },
    async getDetail(id) {
      if (this.show) {
        this.$refs.nxTable.search(1);
      } 
    },
    async search(pagination) {
      const { pageNum, pageSize } = pagination;
      let params = { recordId: this.id, pageNum, pageSize };
      const { data } = await getUdsItemList(params);

      this.tableData = data.list;
      pagination.total = data.total;
    },
    async handExport() {
      let params = { recordId: this.id };
      const { data } = await exportUdsItemList(params);
      this.$message.success("导出任务已提交，请前往导出文件列表查看");
    },
  },
};
</script>
<style scoped lang="scss"></style>
